import { Grid } from '@mui/material';
import { StatsProps } from '@/components/pickem-admin/OptionPreview/MatchPlayerStats.tsx';

export const MatchTitle = ({ matchStats, matchId }: StatsProps) => {
  if (!matchStats) return null;

  const match = matchStats.find((match) => match?.MatchFeedId === matchId);
  if (!match) return null;

  return (
    <Grid container sx={{ textAlign: 'center' }}>
      <Grid item xs={5} sx={{ fontSize: 8 }}>
        {match.HomeTeamName}
      </Grid>
      <Grid item xs={1} sx={{ fontSize: 10 }}>
        {match.HomeTeamScore}
      </Grid>
      <Grid item xs={1} sx={{ fontSize: 10 }}>
        {match.AwayTeamScore}
      </Grid>
      <Grid item xs={5} sx={{ fontSize: 8 }}>
        {match.AwayTeamName}
      </Grid>
      <Grid item xs={12} sx={{ fontSize: 7 }}>
        {match.StartDateUtc}
      </Grid>
      <Grid item xs={12} sx={{ fontSize: 7 }}>
        {match.Status}
      </Grid>
    </Grid>
  );
};
